import { date as datePattern, railsDate as railsDatePattern } from '@/helpers/regex'

export const formatDateToPtBR = (rawDbDate) => {
  if (!rawDbDate || !railsDatePattern.test(rawDbDate)) return rawDbDate

  const [year, month, day] = rawDbDate.split('-')

  return `${day}/${month}/${year}`
}

export const formatDateToDbFormat = (ptBrDate) => {
  if (!ptBrDate || !datePattern.test(ptBrDate)) return ptBrDate

  const [day, month, year] = ptBrDate.split('/')

  return `${year}-${month}-${day}`
}
